// extracted by mini-css-extract-plugin
module.exports = {"content":"retention-dialog_content_2Eto1","text":"retention-dialog_text_1fCdb"};